import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPendingIntegrationReturnPath } from "@/lib/integrations/integrationReturnPath";

const CALLBACK_RETURN_TO_PARAM = "integration_return_to";

const INTEGRATION_CALLBACK_PARAMS = [
  "calendar_connected",
  "calendar_error",
  "zoom_connected",
  "zoom_error",
  "linkedin_connected",
  "linkedin_error",
  "outlook_connected",
  "outlook_error",
  "fireflies_connected",
  "fireflies_error",
  "readai_connected",
  "readai_error",
  "otter_connected",
  "otter_error",
] as const;

function hasIntegrationCallbackParams(search: string) {
  const params = new URLSearchParams(search);
  return INTEGRATION_CALLBACK_PARAMS.some((key) => params.has(key));
}

export function IntegrationCallbackRedirectGate() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasIntegrationCallbackParams(location.search)) return;

    const params = new URLSearchParams(location.search);
    const callbackReturnPath = params.get(CALLBACK_RETURN_TO_PARAM);
    const safeCallbackReturnPath =
      callbackReturnPath && callbackReturnPath.startsWith("/") && !callbackReturnPath.startsWith("//")
        ? callbackReturnPath
        : null;
    const pendingReturnPath = getPendingIntegrationReturnPath();
    const nextPath = safeCallbackReturnPath ?? pendingReturnPath;

    if (!nextPath) return;
    const targetPathname = new URL(nextPath, window.location.origin).pathname;
    if (location.pathname === targetPathname) return;

    navigate(`${nextPath}${location.search}`, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}
